module.exports = __webpack_public_path__ + "img/certificate.b6b0bf7a.png";